var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeOrderRecieved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 48,
    viewBox: "0 0 215 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.07812 32.4367C2.07812 32.4367 10.4086 31.3611 19.8798 33.9451C37.8936 38.8596 38.9212 29.8599 45.6009 25.5204C51.712 21.5503 56.7732 23.9726 63.5776 28.8278C68.5961 32.4087 75.9099 38.4196 83.4841 37.4519C90.4078 36.5673 95.3161 29.5174 104.913 27.7245C112.519 26.3035 118.7 30.2073 127.459 28.8278C139.341 26.9563 144.648 15.9388 153.14 15.9388C163.621 15.9388 171 6.62061 180.535 6.62061C190.013 6.62061 191.299 12.0999 201.668 15.9388C209.594 18.8737 213.408 15.9388 213.408 15.9388V47.3879H2.07812V32.4367Z",
    fill: "url(#paint0_linear_8655_9950)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07812 27.552C2.07812 27.552 10.4086 26.492 19.8798 29.0385C37.8936 33.8819 38.9212 25.0125 45.6009 20.7359C51.712 16.8232 56.7732 19.2104 63.5776 23.9953C68.5961 27.5244 75.9099 33.4483 83.4841 32.4946C90.4078 31.6229 95.3161 24.6749 104.913 22.908C112.519 21.5075 118.7 25.3549 127.459 23.9953C139.341 22.151 144.648 11.2929 153.14 11.2929C163.621 11.2929 171 2.0874 180.535 2.0874C190.013 2.0874 190.517 7.50962 200.885 11.2929C208.811 14.1853 213.408 11.2929 213.408 11.2929",
    stroke: "#26617D",
    strokeWidth: 2.71268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8655_9950",
    x1: 40.2709,
    y1: 27.3061,
    x2: 40.2709,
    y2: 47.3879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26617D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOrderRecieved);
export default __webpack_public_path__ + "static/media/home-order-recieved.80e0d724b6ca2f7a9c6bdb08603eb9bd.svg";
export { ForwardRef as ReactComponent };